module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Choose new status for candidates from deleted status.","confirm":"Confirm","delete":"Delete status","warning":"The status will be removed in all vacancies!"}}')
  delete Component.options._Ctor
}
